import useAPI from '@/hooks/useAPI';
import AppointmentsRepository, {
  GetCalendarAppointmentsParams
} from '@/repositories/AppointmentsRepository';
import { Appointment } from '@/types/appointments';

export const useAppointmentCalendar = (params: GetCalendarAppointmentsParams) => {
  const appointmentsRepository = AppointmentsRepository();

  return useAPI<Appointment[]>({
    queryKey: ['getCalendarAppointments', params.start, params.end],
    queryFn: async () => {
      return await appointmentsRepository.getCalendarAppointments(params);
    },
    // Keep showing the previous date range's appointments while the next
    // range loads, instead of the calendar unmounting on every navigation.
    keepPreviousData: true
  });
};
